<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-28 10:47:30
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 20:10:12
 * @Description: 首页头部导航
 -->
<template>
  <div class="header-nav-wrapper">
    <div class="header-nav">
      <router-link class="logo" to="/">
        <img src="https://files.jinr.com/jinr-index/img/logo.png" alt="" srcset="" />
      </router-link>
      <div class="nav-wrapper">
        <div
          class="nav-item"
          v-for="(item, index) in navList"
          :key="index"
          :class="[{ active: index === activeIndex }]"
          @click="handleRoute(item, index)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      navList: [
        {
          title: '首页',
          path: '/'
        },
        {
          title: '鲸鱼优选',
          path: '/perfect-select'
        },
        {
          title: '我要借款',
          path: '/borrowing'
        },
        {
          title: '信息披露',
          path: '/information'
        },
        {
          title: '党建工作',
          path: '/party-index'
        },
        {
          title: '关于我们',
          path: '/about-us'
        }
      ],
      activeIndex: 0
    };
  },
  computed: {
    routerPath() {
      return window.location.href.split('#/')[1];
    }
  },
  watch: {
    $route(to) {
      if (to.path !== '/about-us/party/list') {
        this.locationRouter(to.path);
      } else {
        // 产品的需求，把党建工作单独拿出来。。。。
        // 路由激活状态写死
        this.activeIndex = 4;
      }
    }
  },
  created() {
    // this.locationRouter();
  },
  methods: {
    handleRoute(route, index) {
      this.activeIndex = index;
      this.$router.push(route.path);
    },
    locationRouter(path) {
      this.navList.forEach((item, index) => {
        const tempStr = `/${path.split('/')[1]}`;
        if (item.path === tempStr) {
          this.activeIndex = index;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.header-nav-wrapper {
  background: #ffffff;
  .header-nav {
    width: 1200px;
    height: 56px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    padding: 0 0 0 100px;
    box-sizing: border-box;
  }
  .logo {
    display: flex;
    margin: auto 0;
    height: 58px;
    justify-content: center;
    align-items: center;
    img {
      height: 70%;
    }
  }
  .nav-wrapper {
    display: flex;
    margin: 0 0 0 100px;
    .nav-item {
      width: 148px;
      height: 56px;
      font-family: 'PingFangSC-Regular';
      font-size: 16px;
      text-align: center;
      color: #333333;
      line-height: 56px;
      cursor: pointer;
    }
    .nav-item.active {
      background: #2c6eff;
      color: #ffffff;
      font-weight: 600;
    }
  }
}
</style>
